export interface ITextItem
{
  id: string;
  name: string;
}

export class ITextItem implements ITextItem {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}




// WEBPACK FOOTER //
// ./src/app/models/ITextItem.ts